import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69cb592fc3f8480013ed3de3/atelier/src/app/waitlist/page.tsx");
